import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../styles/TopicConfirmModal.css";

function TopicConfirmModal({ isOpen, onClose, onConfirm, topicTitle }) {
    const { t } = useTranslation();

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [onClose]);

    if (!isOpen) return null;

    return (
        <div className="topic-modal-overlay">
            <div className="topic-modal-content">
                <h2>{t("topicsPage.confirmDeleteTitle")}</h2>
                <p>{t("topicsPage.confirmDeleteMessage")}</p>
                <p>
                    <strong>{topicTitle}</strong>?
                </p>

                <div className="topic-modal-actions">
                    <button className="btn-delete-modal" onClick={onConfirm}>
                        {t("topicsPage.confirmDeleteButton")}
                    </button>
                    <button className="btn-cancel-modal" onClick={onClose}>
                        {t("topicsPage.cancelButton")}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default TopicConfirmModal;
